import { render } from "./DanhSachDeTai2.vue?vue&type=template&id=3b40b006&ts=true"
import script from "./DanhSachDeTai2.vue?vue&type=script&lang=ts"
export * from "./DanhSachDeTai2.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__